import UpdateBasketItemRequestModelBase from '../_generated/modelBases/update-basket-item-request-model-base';

export default class UpdateBasketItemRequestModel extends UpdateBasketItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
